import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userReducer from "../redux/userRedux";
import cityReducer from '../redux/cityRedux';
import subsReducer from '../redux/subsRedux';
import servcieReducer from '../redux/serviceRedux';
import categoryReducer from "../redux/categoryRedux";
import subcategoryReducer from "../redux/subcategoryRedux";
import appointmentReducer from "../redux/appointmentRedux";
import reportReducer from "../redux/reportRedux";
import ratingReducer from "../redux/ratingRedux";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";


const rootReducer = combineReducers({
  user: userReducer,
  city: cityReducer,
  category: categoryReducer,
  subcategory: subcategoryReducer,
  subscription: subsReducer,
  service: servcieReducer,
  appointments: appointmentReducer,
  reports: reportReducer,
  rating: ratingReducer
});

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: ["city", "category", "subcategory", "subscription", "service", "appointments", "reports", "rating"],
};


const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export let persistor = persistStore(store);
